import Moment from 'moment';
import { ActionTypes } from '../constants';
import { LogTypes } from './constants';

const defaults = {
  logs: [],
};

export interface ActionType {
  type: string;
  payload: any;
}

export default (state = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.SERVERAPP_ADD_LOG: {
      const { logs } = state;
      const { log } = action.payload;
      const newLines = [...logs];
      if (logs.length >= 100) {
        newLines.splice(0, 1);
      }
      const formattedLine = `${Moment(new Date()).format('YYYY-MM-DD hh:mm:ss')} - ${
        log.logLevel
      } - ${log.message}`;
      return {
        ...state,
        logs: newLines.concat(formattedLine),
      };
    }
    case ActionTypes.SERVERAPP_CLEAR_LOGS: {
      return {
        ...state,
        logs: [],
      };
    }
    default: {
      const { logs } = state;
      const newLines = [...logs];
      if (logs.length >= 100) {
        newLines.splice(0, 1);
      }
      let formattedLine = '';
      if (action.type.indexOf('FAILURE') >= 0) {
        formattedLine = `${Moment(new Date()).format('YYYY-MM-DD HH:MM:ss')} - ERROR - ${
          LogTypes[action.type]
        }`;
        return {
          ...state,
          logs: newLines.concat(formattedLine),
        };
      }
      if (action.type.indexOf('SUCCESS') >= 0) {
        formattedLine = `${Moment(new Date()).format('YYYY-MM-DD HH:MM:ss')} - SUCCESS - ${
          LogTypes[action.type]
        }`;
        return {
          ...state,
          logs: newLines.concat(formattedLine),
        };
      }
      if (action.type.indexOf('REQUEST') >= 0) {
        formattedLine = `${Moment(new Date()).format('YYYY-MM-DD HH:MM:ss')} - REQUEST - ${
          LogTypes[action.type]
        }`;
        return {
          ...state,
          logs: newLines.concat(formattedLine),
        };
      }
      return { ...state };
    }
  }
};
